import { render } from "./formInput.vue?vue&type=template&id=2af540fe&scoped=true"
import script from "./formInput.vue?vue&type=script&lang=js"
export * from "./formInput.vue?vue&type=script&lang=js"

import "./formInput.vue?vue&type=style&index=0&id=2af540fe&scoped=true&lang=css"

import exportComponent from "/home/forge/clients-dev.printpigeons.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2af540fe"]])

export default __exports__